<!-- =========================================================================================
    File Name: tableFilterSorter.vue
    Description: Add filter and sorting functionality to table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <b-overlay
      :show="show"
      :variant="variant"
      :opacity="opacity"
      :blur="blur"
      rounded="sm"
      spinner-variant="primary"
    >
      <b-card class="track-log">
        <h4 class="heading">
          {{ $t("TrackingLogs") }}
          <feather-icon
            id="export"
            icon="DownloadCloudIcon"
            svgClasses="w-5 h-5 hover:text-danger stroke-current"
            class="ml-5"
            :title="$t('Export')"
            v-b-modal.modal-1
          />
        </h4>
        <b-modal
          id="modal-1"
          :title="$t('ExportToExcel')"
          :ok-title="$t('Export')"
          :cancel-title="$t('Cancel')"
          @ok="exportToExcel"
          @cancel="clearFields"
          @close="clearFields"
          class="export-options"
          centered
        >
          <b-form-input
            v-model="fileName"
            class="w-full"
            :placeholder="$t('FileName')"
          ></b-form-input>
          <v-select v-model="selectedFormat" :options="formats" class="my-2"
            ><template v-slot:option="option">
              <span :class="option.icon">{{ option.label }} </span>
              <feather-icon
                v-if="selectedFormat == option.label"
                icon="CheckIcon"
                class="float-right"
                svgClasses="w-5 h-5"
              />
            </template>
          </v-select>
          <div class="flex walk-card">
            <span class="mr-3">{{ $t("CellAutoWidth") }}:</span>
            <b-form-checkbox
              v-model="cellAutoWidth"
              size="lg"
              name="cell_width"
              switch
            >
            </b-form-checkbox>
          </div>
        </b-modal>
        <export
          v-if="activePrompt"
          :val="headerVal"
          :title="headerTitle"
        ></export>

        <div class="vx-row">
          <div
            class="vx-col w-full xs:w-full sm:w-full lg:w-1/3 md:w-1/3 xl:w-1/3 mt-5"
          >
            <date-picker
              class="w-full"
              range
              size="large"
              v-model="start_date"
              name="start_date"
              :placeholder="$t('Date')"
              @input="getLogs"
            ></date-picker>
          </div>

          <v-select
            class="vx-col w-full xs:w-full sm:w-full lg:w-1/3 md:w-1/3 xl:w-1/3 mt-5"
            v-model="company_id"
            :options="getFilteredCompanies"
            :placeholder="$t('Select') + $t('Company').toLowerCase()"
            @input="getLogs"
          />

          <v-select
            class="vx-col w-full xs:w-full sm:w-full lg:w-1/3 md:w-1/3 xl:w-1/3 mt-5"
            v-model="event"
            :options="actions"
            :placeholder="$t('Select') + $t('TypeOfEvent').toLowerCase()"
            @input="getLogs"
          />
          <v-select
            class="vx-col w-full xs:w-full sm:w-full lg:w-1/3 md:w-1/3 xl:w-1/3 mt-5"
            v-model="remote_user_id"
            :options="getFilteredRemoteUser"
            :placeholder="$t('Select') + $t('RemoteUser').toLowerCase()"
            @input="getLogs"
          />

          <v-select
            class="vx-col w-full xs:w-full sm:w-full lg:w-1/3 md:w-1/3 xl:w-1/3 mt-5"
            v-model="staff_user_id"
            :options="getFilteredStaffUser"
            :placeholder="$t('SelectStaff')"
            @input="getLogs"
          />
          <v-select
            class="vx-col w-full xs:w-full sm:w-full lg:w-1/3 md:w-1/3 xl:w-1/3 mt-5"
            v-model="device_id"
            :options="getFilteredDevice"
            :placeholder="$t('Select') + $t('Device').toLowerCase()"
            @input="getLogs"
          />
        </div>

        <div class="export-table mt-5">
          <b-col lg="5" class="my-1 p-2 float-right">
            <b-form-group
              label-for="filter-input"
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              class="mb-0"
            >
              <b-input-group size="md">
                <b-input-group-prepend is-text>
                  <b-icon icon="search"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  id="filter-input"
                  v-model="filter"
                  type="search"
                  :placeholder="$t('Search')"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-table
            :current-page="currentPage"
            :per-page="perPage"
            :items="logs"
            :fields="fields"
            :busy="isBusy"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            responsive
            show-empty
            :filter="filter"
            :filter-included-fields="filterOn"
            :empty-text="$t('EmptyData')"
            :empty-filtered-text="$t('EmptyFilter')"
            @filtered="onFiltered"
          >
            <template #head()="data">
              <span>{{ $t(data.label) }}</span>
            </template>

            <!-- rows -->
            <template #cell()="data">
              {{ data.value || "NA" }}
            </template>

            <!-- A custom formatted column -->
            <template #cell(action)="data">
              {{ $t("ActionList")[data.value] }}
            </template>
          </b-table>

          <b-pagination
            v-if="rows > perPage"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            aria-controls="my-table"
            class="float-right"
          ></b-pagination>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import vSelect from "vue-select";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import { getActionList } from "@/utils/helper";
import Export from "@/components/export/Export.vue";
import $ from "jquery";
getActionList;
export default {
  components: {
    "v-select": vSelect,
    DatePicker,
    Export,
  },
  data() {
    return {
      headerTitle: [
        "CompanyName",
        "StaffUserName",
        "RemoteUserName",
        "Device",
        "CreatedDate",
      ],
      headerVal: [
        "company_name",
        "staff_full_name",
        "user_name",
        "device_name",
        "creation_date",
      ],
      logs: [],
      device: [],
      device_id: null,
      activePrompt: null,
      fileName: "",
      staff_user_id: null,
      remote_user_id: null,
      event: [],
      start_date: null,
      end_date: null,
      remote_user: [],
      staff_user: [],
      companies: [],
      company_id: null,
      perPage: 10,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      isBusy: false,
      formats: ["xlsx", "csv", "txt"],
      selectedFormat: "xlsx",
      cellAutoWidth: true,
      totalRows: 1,
      fields: [
        {
          key: "company_name",
          label: "CompanyName",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "staff_full_name",
          label: "StaffUserName",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "user_name",
          label: "RemoteUserName",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "device_name",
          label: "Device",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "action",
          label: "Action",
          sortable: true,
          sortDirection: "desc",
        },

        {
          key: "creation_date",
          label: "CreatedDate",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      actions: getActionList(this.$t("ActionList")),
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
    };
  },

  watch: {
    "$i18n.locale": {
      handler: function (value) {
        this.actions = getActionList(this.$t("ActionList"));
        this.event.label = this.$t("ActionList")[this.event.value];
      },
    },
  },

  computed: {
    rows() {
      return this.logs.length;
    },
    getFilteredCompanies() {
      let arr = [];
      this.companies.forEach((o, i) => {
        var obj = {};
        obj["label"] = o.company_name;
        obj["value"] = o.company_id;
        arr.push(obj);
      });
      return arr;
    },

    getFilteredDevice() {
      let arr = [];
      this.device.forEach((o, i) => {
        var obj = {};
        obj["label"] = o.device_full_name;
        obj["value"] = o.device_id;
        arr.push(obj);
      });
      return arr;
    },

    getFilteredRemoteUser() {
      let arr = [];
      this.remote_user.forEach((o, i) => {
        var obj = {};
        obj["label"] = o.user_full_name;
        obj["value"] = o.user_id;
        arr.push(obj);
      });
      return arr;
    },

    getFilteredStaffUser() {
      let arr = [];
      this.staff_user.forEach((o, i) => {
        var obj = {};
        obj["label"] = o.staff_full_name;
        obj["value"] = o.staff_id;
        arr.push(obj);
      });
      return arr;
    },
  },

  created() {
    this.getStaffs();
    this.getLogs();
  },

  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    busy() {
      this.isBusy = !this.isBusy;
    },
    /**
     *
     * createdDate   method
     **/
    createdDate(value) {
      return moment(value).format("DD/MM/YYYY hh:mm A");
    },
    /**
     *  exportToExcel method for export file according to format
     **/
    exportToExcel() {
      import("@/assets/utils/export").then((excel) => {
        const list = this.logs;
        this.headerTitle.map((title, index) => {
          this.headerTitle[index] = this.$t(title);
        });

        const data = this.formatJson(this.headerVal, list);
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat,
        });
        this.headerTitle = [
          "CompanyName",
          "StaffUserName",
          "RemoteUserName",
          "Device",
          "CreatedDate",
        ];
        this.clearFields();
      });
    },
    /**
     *  @params filterVal ,jsonData
     * formatJson   method  for export file according to format
     **/
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },
    /**
     *
     * clearFields   method  for export selected format
     **/
    clearFields() {
      this.fileName = "";
      this.cellAutoWidth = true;
      this.selectedFormat = "xlsx";
    },

    /**
     *
     * getLogs   method  for list all users data
     **/
    getLogs() {
      this.show = true;
      this.success = "";
      this.error = "";
      $(".item-pagination").first().click();
      let data = {
        company_id: this.company_id != null ? this.company_id.value : null,
        start_date: this.start_date ? this.start_date[0] : null,
        end_date: this.start_date ? this.start_date[1] : null,
        type_of_event: this.event != null ? this.event.value : null,
        user_id: this.remote_user_id != null ? this.remote_user_id.value : null,
        device_id: this.device_id != null ? this.device_id.value : null,
        staff_id: this.staff_user_id != null ? this.staff_user_id.value : null,
      };

      this.$store
        .dispatch("GetTrackingLogList", data)
        .then((res) => {
          this.show = false;
          this.logs = res.data.data;
          this.totalRows = this.logs.length;  
        })
        .catch((error) => {
          this.$log.error(
            "File : List.vue | Function : getLogs() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error = this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          // Error response
          return false;
        });
    },

    /**
     *
     * getStaffs   method  for list all staffs data
     **/
    getStaffs() {
      this.success = "";
      this.error = "";
      this.show = true;
      let data = {
        company_id: this.company_id != null ? this.company_id.value : null,
      };
      this.$store
        .dispatch("getTrackingDataFilter", data)
        .then((res) => {
          this.show = false;
          this.staff_user = res.data.staffs;
          this.device = res.data.devices;
          this.companies = res.data.companies;
          this.remote_user = res.data.users;
        })
        .catch((error) => {
          this.$log.error(
            "File : List.vue | Function : getstaffs() | Error :",
            error
          );

          // Error response
          this.show = false;
          // Error response
          this.error = this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
  },
};
</script>

<style lang="stylus" scope>
.heading {
  margin-bottom: 20px;
}

.add {
  position: absolute;
  margin-top: 10px;
}

.action {
  margin-left: 20px;
  display: inline;
}

.con-vs-tooltip {
  display: inline;
}

.mx-datepicker-range {
  width: 100% !important;
}
</style>